// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__Sq2pf","rootCenter":"LoadMoreObserver_rootCenter__3aY9p","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2C1hh"};